const constants = {
  brushSize: 5,
  defaultColor: '#000000',
  textSize: 24,
};

export default constants;
